import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=c7de456e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7de456e')) {
      api.createRecord('c7de456e', component.options)
    } else {
      api.reload('c7de456e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=c7de456e&", function () {
      api.rerender('c7de456e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2go3VxX00tbNj/JS/comp/IncreaseNumber.vue"
export default component.exports